import { apiGet, type RequestOptions } from './index'

export interface ClockPrepUsageClock {
  day_id: number
  date: string | null
  window_start: string | null
  window_end: string | null
  title: string | null
  items?: ClockPrepUsageClockItem[]
}

export interface ClockPrepUsageClockItem {
  day_item_id: number
  item_type: string
  title: string | null
  scheduled_start: string | null
  scheduled_end: string | null
}

export interface ClockPrepUsageItem {
  prep_item_id: number
  clocks: ClockPrepUsageClock[]
}

export interface ClockPrepUsageResponse {
  station_id: number
  now: string
  items: ClockPrepUsageItem[]
  request_id?: string
}

export const getClockPrepUsage = async (
  stationId: number,
  prepIds: number[],
  options?: RequestOptions,
): Promise<ClockPrepUsageResponse> => {
  const search = new URLSearchParams({ station_id: String(stationId) })
  prepIds.forEach((id) => search.append('prep_ids[]', String(id)))
  return apiGet<ClockPrepUsageResponse>(`clock/prep/usage?${search.toString()}`, options)
}
